import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Application } from "@/contexts/ApplicationContext";

interface IdentityConfirmationSectionProps {
  application: Application;
  setApplication: (app: Application) => void;
}

const IdentityConfirmationSection: React.FC<IdentityConfirmationSectionProps> = ({
  application,
  setApplication,
}) => {
  const normalizedSex =
    application.basicDetails.sex && application.basicDetails.sex.length
      ? application.basicDetails.sex[0].toUpperCase() +
        application.basicDetails.sex.slice(1).toLowerCase()
      : undefined;

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setApplication({
      ...application,
      basicDetails: {
        ...application.basicDetails,
        dateOfBirth: value,
      },
    });
  };

  const handleSexChange = (value: string) => {
    setApplication({
      ...application,
      basicDetails: {
        ...application.basicDetails,
        sex: value,
      },
    });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold text-jungle">Identity Confirmation</h2>
      <p className="text-sm text-muted-foreground">
        Make sure these details match exactly what appears on your
        government-issued ID (e.g., passport or driving licence).
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div className="space-y-2">
          <Label htmlFor="identity-first-name">First Name</Label>
          <Input
            id="identity-first-name"
            value={application.basicDetails.firstName}
            onChange={(e) =>
              setApplication({
                ...application,
                basicDetails: {
                  ...application.basicDetails,
                  firstName: e.target.value,
                },
              })
            }
            placeholder="Enter your first name"
            className="bg-white"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="identity-last-name">Last Name</Label>
          <Input
            id="identity-last-name"
            value={application.basicDetails.lastName}
            onChange={(e) =>
              setApplication({
                ...application,
                basicDetails: {
                  ...application.basicDetails,
                  lastName: e.target.value,
                },
              })
            }
            placeholder="Enter your last name"
            className="bg-white"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div className="space-y-2">
          <Label htmlFor="identity-dob">Date of Birth</Label>
          <Input
            id="identity-dob"
            type="date"
            value={application.basicDetails.dateOfBirth}
            onChange={handleDateChange}
            className="bg-white"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="identity-sex">Sex</Label>
          <Select
            value={normalizedSex}
            onValueChange={handleSexChange}
          >
            <SelectTrigger id="identity-sex" className="bg-white">
              <SelectValue placeholder="Select your sex" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Male">Male</SelectItem>
              <SelectItem value="Female">Female</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default IdentityConfirmationSection;
